import { render, staticRenderFns } from "./SSelectBrandChamber.vue?vue&type=template&id=7243bbae"
import script from "./SSelectBrandChamber.vue?vue&type=script&lang=js"
export * from "./SSelectBrandChamber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports